import dayjs from "../../../utility/dayjs";
import Utils from "../../../utility";

const initialState = {
  POList: [],
  order: "DESC",
  sortField: "createdAt",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  PODetail: [],
  startDate: dayjs(),
  endDate: dayjs(),
  warehouseId: "",
  vender: "",
};
export const warehousePOReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.WAREHOUSE_PO}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
